<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { ModelListSelect } from "vue-search-select";
import axios from "axios";
import { mapGetters, mapActions, mapState } from "vuex";
import moment from "moment";
/**
 * Advanced table component
 */
export default {
  page: {
    title: "Pending Laboratory Tests",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
  },
  data() {
    return {
      search_status: false,
      filterdArray: [],
      advancedsearch: {
        search: "",
        date1: "",
        date2: moment(new Date()).format("YYYY-MM-DD"),
      },
      title: "Pending Lab Tests",
      items: [
        {
          text: "Laboratory Section",
          href: "#",
        },
        {
          text: "Tests Pending Results",
          active: true,
        },
      ],
      flagOptions: [
        { value: "", label: "Not Applicable" },
        { value: "Low", label: "Lower" },
        { value: "Normal", label: "Normal" },
        { value: "High", label: "Higher" },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 15,
      pageOptions: [15, 25, 50, 100, 250, 500, 1000],
      filter: null,
      filterOn: [],
      sortBy: "id",
      sortDesc: true,
      definedData: {
        testName: "",
        order_id: "",
        result_id: "",
        technician: "",
        description: "",
      },
      undefinedData: {
        testName: "",
        order_id: "",
        technician: "",
        description: "",
      },
      machineData: {
        testName: "",
        order_id: "",
      },
      parameterData: {
        testName: "",
        order_id: "",
        technician: "",
        description: "",
        parameters: "",
      },
      TestConsumable:{},
      usedData:{
        consumable:'',
        quantity:'1',
        test:'',
        visit:'',
      },
      noParameterFound: "",
      dataRequired: "",
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
          {
              key: "patientCode",
              sortable: true,
              label: "PATIENT No.",
          },
        {
          key: "name_field",
          sortable: true,
          label: "PATIENT NAME",
        },
        // {
        //   key: "branch.name",
        //   sortable: true,
        //   label: "BRANCH",
        // },
        {
          key: "labrequest",
          sortable: false,
          label: "TEST DONE",
        },
      ],
      model_id: "",
      resultIdError: "",
      commentError: "",
      consumableError:"",
      quantityError:"",
    };
  },

  computed: {
    ...mapGetters("laboratory", [
      "pending_test",
      "test_options",
      "AddingResultStatus",
    ]),
    ...mapGetters("staffModule", ["clinic_staff"]),
    ...mapGetters("auth", ["user_permissions"]),
    ...mapState("notification", [
      "notificationtype",
      "notification_message",
      "notification_show",
    ]),

    /**
     * Total no. of records
     */

    rows() {
      return this.filterdArray ? this.filterdArray.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.filterdArray ? this.filterdArray.length : 1;
  },

  watch: {
    pending_test(newVal) {
      if (newVal) {
        this.AssignTest();
      }
    },
    notification_show(newValue) {
      // Do whatever makes sense now
      if (newValue == true) {
        this.closeMode(this.model_id);
        if (this.notificationtype == "success") {
          this.$toast.success(this.notification_message.msg);
        } else {
          this.$toast.error(this.notification_message.msg);
        }
      }
    },
  },

  methods: {
    remove_commas(amount) {
      return amount.replace(/,/g, "");
    },

    AssignTest() {
      this.filterdArray = this.pending_test;
    },
    SearchTest() {
      this.search_status = true;
      axios
        .post("filter_pending_tests", this.advancedsearch)
        .then((response) => {
          this.search_status = false;
          this.filterdArray = response.data.data;
        })
        .catch(() => {
          this.search_status = false;
        });
    },
    //======== HANDLE ADDING DEFINED RESULT OPTIONS=========
    resetModalDefined() {
      this.definedData.testName = "";
      this.definedData.order_id = "";
      this.definedData.result_id = "";
      this.definedData.technician = "";
      this.definedData.description = "";
      this.resultIdError = "";
    },
    // SHOW DEFINED RESULT MODAL -=====
    showResultModal(test) {
      let defined = {
        testName: test.test.name,
        order_id: test.id,
        result_id: "",
        technician: "",
        description: test.test.description,
      };
      this.definedData = defined;
      this.FetchDefinedOptions(test.test.id);
    },
    saveDefined(modalId) {
      this.model_id = modalId;
      // Exit when the form isn't valid
      if (this.definedData.result_id == "") {
        this.resultIdError = "Result field is required";
        return;
      } else {
        this.resultIdError = "";
      }
      // dispatch the saving action
      this.saveDefinedResult(this.definedData);
    },

    //======== HANDLE ADDING UNDEFINED OPTIONS=========
    undefinedModal(test) {
      this.undefinedData.testName = test.test.name;
      this.undefinedData.order_id = test.id;
      this.undefinedData.technician = "";
      this.undefinedData.description = test.test.description;
    },

    saveUndefined(modalId) {
      this.model_id = modalId;
      // Exit when the form isn't valid
      if (this.undefinedData.description === null) {
        this.commentError = "Result Comment field is required";
        return;
      } else {
        this.commentError = "";
      }
      // dispatch the saving action
      this.saveUndefinedResult(this.undefinedData);
    },

    // SHOW ADD CONSUMABLE MODAL
    consumableModal(test, data){
      // alert(test.test.id)
      this.usedData.test = test.test.id
      this.usedData.visit = data.id
      axios
          .get("test/consumable/" + test.test.id)
          .then((response) => (this.TestConsumable = response.data));
    },

    saveConsumable(modalId) {
      this.model_id = modalId;
      // Exit when the form isn't valid
      if (this.usedData.consumable === null || this.usedData.consumable === "") {
        this.consumableError = "Consumable field is required";
        return;
      } else {
        this.consumableError = "";
      }

      if (this.usedData.quantity === null || this.usedData.quantity < 1) {
        this.quantityError = "Used Quantity field is required";
        return;
      } else {
        this.quantityError = "";
      }
      // dispatch the saving action
      this.saveConsumed(this.usedData);
    },

    //==RESET MODAL===========
    resetModalUndefined() {
      this.undefinedData.testName = "";
      this.undefinedData.order_id = "";
      this.undefinedData.result_id = "";
      this.undefinedData.technician = "";
      this.undefinedData.description = "";
    },

    //======= HANDLE MACHINE BASED RESULT ========
    machineModal(test) {
      this.machineData.testName = test.test.name;
      this.machineData.order_id = test.id;
    },

    saveMachine(modalId) {
      this.model_id = modalId;
      // dispatch the saving action
      this.saveMachineResult(this.machineData);
    },

    resetMachine() {
      this.machineData.testName = "";
      this.machineData.order_id = "";
    },

    //======== HANDLE ADDING PARAMETER BASED RESULT=========
    resetModalparameter() {
      this.parameterData.testName = "";
      this.parameterData.order_id = "";
      this.parameterData.technician = "";
      this.parameterData.description = "";
      this.parameterData.parameters = "";
      this.noParameterFound = "";
      this.dataRequired = "";
    },



    // SHOW DEFINED RESULT MODAL -=====
    parameterModal(test) {
      this.parameterData.testName = test.test.name;
      this.parameterData.order_id = test.id;
      this.parameterData.technician = "";
      this.parameterData.description = test.test.description;

      axios
        .get("testparameter/" + test.test.id + "/" + test.visit)
        .then((response) => (this.parameterData.parameters = response.data));
    },

    resetMsg() {
      this.noParameterFound = "";
      this.dataRequired = "";
    },

    saveParameter(modalId) {
      this.model_id = modalId;
      //Check if there are parameters for match this patient
      if (this.parameterData.parameters.length < 1) {
        this.noParameterFound =
          "Sorry! You can not proceed past here, because there are no results to save";
        return;
      }

      //Check if empty submission
      if (
        this.parameterData.parameters[0].parameter_result === "" &&
        this.parameterData.parameters[1].parameter_result === ""
      ) {
        this.dataRequired =
          "At least " +
          this.parameterData.parameters[0].parameter_name +
          " or " +
          this.parameterData.parameters[1].parameter_name +
          " results are required to proceed";
        return;
      }
      // dispatch the saving action
      this.saveParameterResult(this.parameterData);
    },

    resetResultIdError() {
      this.resultIdError = "";
    },
    resetCommentError() {
      this.commentError = "";
    },

    // CLOSE MODEL
    closeMode(model_id) {
      this.$nextTick(() => {
        this.$bvModal.hide(model_id);
      });
    },

    ...mapActions({
      FetchPending: "laboratory/fetchPendingResult",
      FetchStaff: "staffModule/fetchClinicStaff",
      saveDefinedResult: "laboratory/addDefinedResults",
      saveUndefinedResult: "laboratory/addUndefinedResults",
      saveParameterResult: "laboratory/addParameterResults",
      FetchDefinedOptions: "laboratory/getDefinedOptions",
      saveMachineResult: "laboratory/addMachineResults",
      saveConsumed: "laboratory/addConsumed",
    }),
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
  },
  created() {
    this.FetchPending();
    this.FetchStaff();
    this.AssignTest();
  },
};
</script>
<style scoped>
.loader-line {
  width: 200px;
  height: 3px;
  position: relative;
  overflow: hidden;
  background-color: #ddd;
  margin: 20px auto;
  -webkit-border-radius: 20px;
  -moz-border-radius: 20px;
  border-radius: 20px;
}
.loader-line:before {
  content: "";
  position: absolute;
  left: -50%;
  height: 3px;
  width: 40%;
  background-color: rgb(0, 4, 255);
  -webkit-animation: lineAnim 1s linear infinite;
  -moz-animation: lineAnim 1s linear infinite;
  animation: lineAnim 1s linear infinite;
  -webkit-border-radius: 20px;
  -moz-border-radius: 20px;
  border-radius: 20px;
}

@keyframes lineAnim {
  0% {
    left: -40%;
  }
  50% {
    left: 20%;
    width: 80%;
  }
  100% {
    left: 100%;
    width: 100%;
  }
}
</style>
<template>
  <Layout>
    <Toasts
      :show-progress="true"
      :rtl="true"
      :max-messages="20"
      :time-out="3000"
      :closeable="false"
      :solid="true"
    ></Toasts>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-3">
                <lable for="date1">Filter Start Date</lable>
                <input
                  type="date"
                  v-model="advancedsearch.date1"
                  class="form-control"
                />
              </div>
              <div class="col-md-3">
                <lable for="date2">Filter End Date</lable>
                <input
                  type="date"
                  v-model="advancedsearch.date2"
                  class="form-control"
                />
              </div>
              <div class="col-md-3">
                <br />

                <button v-if="search_status" disabled class="btn btn-primary">
                  FILTER <i class="fa fa-search"></i>
                </button>
                <button v-else @click="SearchTest()" class="btn btn-primary">
                  FILTER <i class="fa fa-search"></i>
                </button>
              </div>
            </div>
            <div class="row">
              <div v-if="search_status" class="loader-line"></div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                bordered
                class="datatables"
                :items="filterdArray"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                  <template #cell(patientCode)="data">
                      {{ data.item.patient.patientCode }}
                  </template>
                <template #cell(name_field)="data">
                  {{ data.item.patient.patientName }} ({{ data.item.patient.age }})
                  <span
                    class="badge rounded-pill bg-success"
                    v-if="data.item.pay_status == 'Cleared'"
                    >Cleared</span>
                  <span
                    class="badge rounded-pill bg-primary"
                    v-else-if="data.item.pay_status == 'insured'"
                    >Insured</span
                  >
                  <span class="badge rounded-pill bg-danger" v-else>
                    Not cleared</span
                  >
                </template>
                <template #cell(labrequest)="data">
                  <table class="table">
                    <thead>
                      <tr>
                        <th>Test Name</th>
                        <th>Date and Time</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(test, t) in data.item.labrequests" :key="t">
                        <td>
                          <span v-if="test.spouse">
                            <div style="color: green">
                              {{ test.test.name }}
                              <sup v-show="test.spouse" class="badge bg-success">Spouse</sup>
                            </div>
                          </span>
                          <span v-else>
                            {{ test.test.name }}
                          </span>
                        </td>
                        <td>{{ test.dateCreated }}</td>
                        <td>
                          <span
                            v-if="
                              user_permissions.add_results
                                ? user_permissions.add_results
                                : false
                            "
                          >
                            <!-- Defined result option -->
                            <b-button
                              size="sm"
                              variant="primary"
                              v-b-modal.definedResult
                              v-if="test.test.result_type == 1"
                              @click="showResultModal(test)"
                              ><i class="fa fa-plus"></i> Add Result
                            </b-button>

                            <!-- undefined result options -->
                            <b-button
                              size="sm"
                              variant="primary"
                              v-b-modal.undefinedResult
                              v-if="test.test.result_type == 2"
                              @click="undefinedModal(test)"
                              ><i class="fa fa-plus"></i> Add Result
                            </b-button>

                            <!-- undefined result options -->
                            <b-button
                              size="sm"
                              variant="primary"
                              v-b-modal.machineResult
                              v-if="test.test.result_type == 3"
                              @click="machineModal(test)"
                              ><i class="fa fa-plus"></i> Add Result
                            </b-button>

                            <!-- parameter based -->
                            <b-button
                              size="sm"
                              variant="primary"
                              v-b-modal.parameterResult
                              v-if="test.test.result_type == 4"
                              @click="parameterModal(test)"
                              ><i class="fa fa-plus"></i> Add Result
                            </b-button>

                            <router-link
                              v-if="test.test.result_type == 5"
                              :to="{
                                name: 'Microbiology',
                                params: {
                                  orderId: test.id,
                                  serviceId: test.test.id,
                                  visitId: test.visit,
                                },
                              }"
                            >
                              <button class="btn btn-primary btn-sm">
                                <i class="fa fa-plus"></i> Add Result
                              </button>
                            </router-link>
                          </span>
                          <span v-else>
                            <button
                              title="You are restricted"
                              class="btn btn-outline-primary btn-sm"
                            >
                              <i class="fa fa-ban"></i> Add Result
                            </button>
                          </span> |
                          <b-button size="sm" variant="secondary"
                              v-b-modal.consumable
                              @click="consumableModal(test, data.item)"
                          ><i class="fa fa-random"></i> Consumable
                          </b-button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </template>
              </b-table>
              <div style="text-align: center">
                <h3 v-if="!pending_test" class="text-primary">
                  <b-spinner
                    class="m-0"
                    variant="primary"
                    role="status"
                  ></b-spinner>
                  Please wait...
                </h3>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <!-- defined Result Modal -->
        <b-modal id="definedResult" @hidden="resetModalDefined" hide-footer>
          <template #modal-title>
            <p class="text-uppercase">
              {{ definedData.testName }} result entry
            </p>
          </template>

          <div class="mb-3">
            <label class="col-form-label">Select Result:</label>
            <model-list-select
              :list="this.test_options ? this.test_options : []"
              v-model="definedData.result_id"
              option-value="id"
              option-text="resultName"
              placeholder="Select Result option"
              @input="resetResultIdError"
            >
            </model-list-select>
            <div class="text-danger" v-if="resultIdError">
              <em>{{ resultIdError }}</em>
            </div>
          </div>

          <div class="mb-3">
            <label class="col-form-label">Select Technician:</label>
            <model-list-select
              :list="this.clinic_staff ? this.clinic_staff : []"
              v-model="definedData.technician"
              option-value="id"
              option-text="staffName"
              placeholder="Select Result option"
            >
            </model-list-select>
          </div>

          <div class="mb-3">
            <label class="col-form-label">Result Comment:</label>
            <b-form-textarea
              id="textarea-rows"
              v-model="definedData.description"
              placeholder="Enter result comments"
              rows="8"
            ></b-form-textarea>
          </div>

          <div class="modal-footer">
            <button
              class="btn btn-secondary"
              @click="$bvModal.hide('definedResult')"
              type="button"
            >
              Close
            </button>
            <button
              class="btn btn-primary"
              type="button"
              @click="saveDefined('definedResult')"
            >
              Save result
              <b-spinner
                v-if="AddingResultStatus"
                variant="light"
                small
                role="status"
              ></b-spinner>
            </button>
          </div>
        </b-modal>

        <!-- undefined Result Modal -->
        <b-modal id="undefinedResult" @hidden="resetModalUndefined" hide-footer>
          <template #modal-title>
            <p class="text-uppercase">
              {{ undefinedData.testName }} result entry
            </p>
          </template>

          <div class="mb-3">
            <label class="col-form-label">Select Technician:</label>
            <model-list-select
              :list="this.clinic_staff ? this.clinic_staff : []"
              v-model="undefinedData.technician"
              option-value="id"
              option-text="staffName"
              placeholder="Select Result option"
            >
            </model-list-select>
          </div>

          <div class="mb-3">
            <label class="col-form-label">Result Comment:</label>
            <b-form-textarea
              id="textarea-rows"
              v-model="undefinedData.description"
              @input="resetCommentError"
              placeholder="Enter Result or result narration"
              rows="8"
            ></b-form-textarea>
            <div class="text-danger">
              <em>{{ commentError }}</em>
            </div>
          </div>

          <div class="modal-footer">
            <button
              class="btn btn-secondary"
              @click="$bvModal.hide('undefinedResult')"
              type="button"
            >
              Close
            </button>
            <button
              class="btn btn-primary"
              type="button"
              @click="saveUndefined('undefinedResult')"
            >
              Save result
              <b-spinner
                v-if="AddingResultStatus"
                variant="light"
                small
                role="status"
              ></b-spinner>
            </button>
          </div>
        </b-modal>

        <!--Machine based result Modal-->
        <b-modal
          id="machineResult"
          ref="modal"
          @hidden="resetMachine"
          hide-footer
        >
          <template #modal-title>
            <p class="text-uppercase">
              Mark {{ machineData.testName }} as resulted
            </p>
          </template>
          <div class="d-block text-center">
            <h5>
              By clicking <code>SAVE RESULTS</code> the system will mark
              <code>{{ machineData.testName }}</code> as done. This test has
              Machine based results. No results entry is expected here in the
              system.
            </h5>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              @click="closeMode('machineResult')"
              class="btn btn-secondary"
            >
              Close
            </button>
            <button
              type="button"
              @click="saveMachine('machineResult')"
              class="btn btn-success"
            >
              Save result
              <b-spinner
                v-if="AddingResultStatus"
                variant="light"
                small
                role="status"
              ></b-spinner>
            </button>
          </div>
        </b-modal>

        <!-- parameter Result Modal -->
        <b-modal
          id="parameterResult"
          size="xl"
          hide-footer
          @hidden="resetModalparameter"
        >
          <template #modal-title>
            <p class="text-uppercase">
              {{ parameterData.testName }} result entry.
            </p>
          </template>
          <div class="mb-3">
            <label class="col-form-label">Select Technician:</label>
            <model-list-select
              :list="this.clinic_staff ? this.clinic_staff : []"
              v-model="parameterData.technician"
              @input="resetMsg"
              option-value="id"
              option-text="staffName"
              placeholder="Select Result option"
            >
            </model-list-select>
          </div>
          <table class="table table-bordered" v-show="parameterData.technician" width="100%">
            <thead>
              <tr>
                <th>#</th>
                <th>Test</th>
                <th>Result</th>
                <th>Flag</th>
                <th>Comment</th>
              </tr>
            </thead>
            <tbody v-if="parameterData.parameters.length">
              <tr
                v-for="(parameter, index) in parameterData.parameters
                  ? parameterData.parameters
                  : []"
                :key="index"
              >
                <td>{{ index + 1 }}</td>
                <td>{{ parameter.parameter_name }}</td>
                <td>
                  <input
                    class="form-control"
                    @input="resetMsg"
                    v-model="parameter.parameter_result"
                    placeholder="Type results.."
                  />
                </td>
                <td width="20%">
                  <model-list-select
                    :list="flagOptions ? flagOptions : []"
                    v-model="parameter.parameter_flag"
                    option-value="value"
                    option-text="label"
                    placeholder="Select Interpretation"
                  >
                  </model-list-select>
                </td>
                <td>
                  <div class="form-group">
                    <textarea
                      class="form-control"
                      rows="3"
                      v-model="parameter.parameter_comment"
                    ></textarea>
                  </div>
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td colspan="5">
                  <div>
                    <b-alert show variant="success">
                      <h4 class="alert-heading">Info! Something Missing!</h4>
                      <p>
                        Either the patient gender and Age/date of birth was not
                        captured during registration OR This test is not
                        recommended for this kind of a patient because of
                        his/her age or gender..
                      </p>
                    </b-alert>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <b-form-group
            v-show="parameterData.parameters.length && parameterData.technician"
            class="mb-3"
            label="Enter Result General Comment"
            label-for="textarea-rows"
          >
            <b-form-textarea
              id="textarea-rows"
              v-model="parameterData.description"
              placeholder="Enter result comments"
              rows="8"
            ></b-form-textarea>
          </b-form-group>
          <div class="text-danger" v-if="this.noParameterFound">
            <em>{{ this.noParameterFound }}</em>
          </div>
          <div class="text-danger" v-if="this.dataRequired">
            <em>{{ this.dataRequired }}</em>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              @click="closeMode('parameterResult')"
              class="btn btn-secondary"
            >
              Close
            </button>
            <button
              type="button"
              @click="saveParameter('parameterResult')"
              class="btn btn-success"
            >
              Save result
              <b-spinner
                v-if="AddingResultStatus"
                variant="light"
                small
                role="status"
              ></b-spinner>
            </button>
          </div>
        </b-modal>

        <!--consumables Modal-->
        <b-modal
            id="consumable"
            ref="modal"
            @hidden="resetMachine"
            hide-footer
        >
          <template #modal-title>
            <p class="text-uppercase">
              Add used consumables
            </p>
          </template>
          <span v-if="TestConsumable.length">
            <div class="mb-3">
              <label class="col-form-label">Select consumable used:</label>
              <select class="form-select" v-model="usedData.consumable" aria-label="Default select example">
                <option selected value="">Select consumable used</option>
                <option v-for="(consumable, i) in TestConsumable" :value="consumable.consumable" :key="i">{{consumable.name}}</option>
              </select>
              <div class="text-danger" v-if="consumableError">
                <em>{{ consumableError }}</em>
              </div>
            </div>
            <div class="mb-3">
              <label class="col-form-label" for="price">Used Quantity:</label>
              <input id="price" v-model="usedData.quantity" class="form-control" type="number">
              <div class="text-danger" v-if="quantityError">
                <em>{{quantityError}}</em>
              </div>
            </div>
            <div class="modal-footer">
            <button type="button" @click="closeMode('consumable')" class="btn btn-secondary">
              Close
            </button>
            <button type="button" @click="saveConsumable('consumable')" class="btn btn-success">
              Save result
              <b-spinner v-if="AddingResultStatus" variant="light" small role="status"
              ></b-spinner>
            </button>
          </div>
          </span>
          <span v-else>
            <h3>No consumable matched with this test</h3>
          </span>
        </b-modal>
      </div>
    </div>
  </Layout>
</template>
